// Config: Actions to trigger loading of local and external Sitecore texts.
import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;

export interface LoanDetailsFormType {
    insuranceConfirmed: boolean;
    orderInsurance: string;
}

export interface FieldUpdateInsuranceAction extends Action<typeof actionTypes.FIELD_UPDATE_INSURANCE> {
    type: typeof actionTypes.FIELD_UPDATE_INSURANCE;
    payload: {
        name: string;
        value: string;
    };
}

// Fields
export const fieldUpdateInsurance = (name: string, value: string): FieldUpdateInsuranceAction => ({
    type: actionTypes.FIELD_UPDATE_INSURANCE,
    payload: { name, value },
});

export type CompletionActions = FieldUpdateInsuranceAction;
